import React from 'react';
import { Col } from 'antd';
import { ButtonsCustom } from './ButtomsCustom';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useResolution886Report } from '@/context/Resolution886Report';
import { useConsolidate } from './hooks';
import type { PDFSectionsResolution886 } from '@/components/views/Resolution886/enums';

interface ConsolidatePDFValues {
	status: boolean;
	include_fields?: PDFSectionsResolution886[];
}

export function FooterButtons(): JSX.Element {
	const { organization, company } = useApplicationContext();
	const { report } = useResolution886Report();

	const { handleConsolidate, consolidateReportLoading, isReportConsolidated } = useConsolidate(
		report,
		company?.id,
		organization?.id
	);

	async function handleOnConsolidatePDF(values: ConsolidatePDFValues): Promise<void> {
		await handleConsolidate(values);
	}

	return (
		<Col>
			<ButtonsCustom
				onConsolidatePDF={handleOnConsolidatePDF}
				hasCustomModal
				hasConsolidated={false}
				isLoadingPDF={consolidateReportLoading}
				consolidated={isReportConsolidated ?? false}
			/>
		</Col>
	);
}
